// src/data/zencode/index.js
import ZenColor from "./zencolor";
import ZenAkku from "./zenakku";
import ZenOrdner from "./zenordner";
import PaperBG from "../../kits/DesignKit/PaperBG";

function withDefaults(project) {
  return {
    ...project,
    bg: PaperBG,
    layout: "default",
  };
}

const ZenProjects = [
  withDefaults(ZenColor),
  withDefaults(ZenAkku),
  withDefaults(ZenOrdner),
];

export default ZenProjects;